export default __webpack_public_path__ + "static/media/previous-question-button-transp.610142b1.png";